import { MarketplacePaymentsDetailsDropdown } from 'src/components/MarketplacePayments/ActionsDropdown/MarketplacePaymentsDetailsDropdown';
import { useGetMarketplacePaymentIdQueryParam } from 'src/components/MarketplacePayments/hooks/useGetMarketplacePaymentIdQueryParam';
import { Content } from 'src/contexts/ContentContext';
import { FilterQueryContextProvider } from 'src/contexts/FilterQueryContext';
import { Stack } from 'src/core/ui';
import { CancellableFormHeader } from 'src/modals/common/CancellableFormHeader';
import { EventEntityHeader } from 'src/modals/common/EventEntityHeader';
import { MarketplacePaymentsDetailsModalBody } from 'src/modals/MaketplacePayments/MarketplacePaymentsDetailsModalBody';
import {
  ModalBody,
  ModalBodyDataContainer,
} from 'src/modals/Modal/Modal.styled';
import { EmptyMarketplacePaymentLineQuery } from 'src/navigations/Routes/Payments/Payments.constants';
import { ContentId } from 'src/utils/constants/contentId';
import { MarketplacePaymentLineQuery } from 'src/WebApiController';

export const MarketplacePaymentsDetailsModal = () => {
  const marketplacePaymentId = useGetMarketplacePaymentIdQueryParam();

  return (
    <FilterQueryContextProvider<MarketplacePaymentLineQuery>
      initialQuery={EmptyMarketplacePaymentLineQuery}
      emptyQuery={EmptyMarketplacePaymentLineQuery}
    >
      <ModalBody>
        <CancellableFormHeader>
          <Stack justifyContent="spaceBetween" alignItems="center">
            <EventEntityHeader
              title={<Content id={ContentId.PaymentDetails} />}
            />
            <MarketplacePaymentsDetailsDropdown
              marketplacePaymentId={marketplacePaymentId}
            />
          </Stack>
        </CancellableFormHeader>
        <ModalBodyDataContainer>
          <MarketplacePaymentsDetailsModalBody
            marketplacePaymentId={marketplacePaymentId}
          />
        </ModalBodyDataContainer>
      </ModalBody>
    </FilterQueryContextProvider>
  );
};
